import moment from 'moment';

export const formatDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
};

export const convertDateStringToISO = (dateString) => { // Ex: 26/10/2023
    return new Date(`${dateString}T00:00:00.000Z`).toISOString();
};

export const toDate = (date) => {
    try {
        const parsedDate = moment(date, ["YYYY-MM-DDTHH:mm:ss", "DD/MM/YYYY"]);
        const convertedDate = parsedDate.format("DD/MM/YYYY");
        return convertedDate;
    } catch (e) {
        console.log('Error:', e.message);
    }
}


export const getDateInISO =(date)=>{
    
         //console.log(moment(date).startOf('day').format("YYYY-MM-DDTHH:mm:ss"))
    return moment(date).startOf('day').format("YYYY-MM-DDTHH:mm:ss");
    //.toISOString().slice(0,10).concat("T00:00:00.000Z")
    
}

export const getDateInInput = (date)=>{
    
    return moment(date);

    
}
export const getDateInTable = (date)=>{
    
    return moment(date).format('l');

    
}